<template>
  <div class="modal fade" :class="{ 'is-open': open }">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <h3 v-if="isEdit" class="modal-title">修改 保障項目</h3>
          <h3 v-else class="modal-title">新增保障項目</h3>
        </div>
        <div class="modal-body">
          <form class="form">
            <div class="row">
              <!-- 保障項目歸類 -->
              <div class="col-12">
                <div class="form-group row">
                  <label class="col-2 text-right">保障項目歸類</label>
                  <div class="col-9">
                    <select
                      class="form-control form-control-inline form-wide"
                      :class="{'is-invalid': isCategoryKindError}"
                      v-model="form.itemKind"
                      >
                      <option value>請選擇</option>
                      <option
                        v-for="(item, index) in options.category"
                        :key="index"
                        :value="item.coveragecategoryid"
                        >
                        {{ item.name }}
                      </option>
                    </select>
                  </div>
                </div>
              </div>
              <div class="col-12">
                <div class="form-group row">
                  <label class="col-2 text-right"
                    >保障項目名稱</label
                    >
                  <div class="col-9">
                    <input
                      type="text"
                      id="itemName"
                      name="itemName"
                      placeholder="保障項目名稱"
                      v-model="form.itemName"
                      :class="{'is-invalid': isItemNameError}"
                      class="form-control form-control-inline"
                      maxlength="20"
                      @input="form.itemName = form.itemName.trim()"
                      @blur="form.itemName = form.itemName.trim()"
                      />
                  </div>
                </div>
              </div>
              <!-- 計算方法 -->
              <div class="col-12">
                <div class="form-group row">
                  <label class="col-2 text-right">計算方法</label>
                  <div class="col-9">
                    <select
                      class="form-control form-control-inline form-wide"
                      :class="{'is-invalid': isMethodNameError}"
                      v-model="form.itemMethodName"
                      >
                      <option value>請選擇</option>
                      <option
                        v-for="(item, index) in options.calculationWay"
                        :key="index"
                        :value="item.value"
                        >
                        {{ item.name }}
                      </option>
                    </select>
                  </div>
                </div>
              </div>
            </div>
          </form>
          <span class="text-red">{{'註：' + (isEdit?'修改':'新增') +'保障項目需與"通路資訊科"人員確認[計算方法]之設定原理'}}</span>
        </div>
        <div class="modal-footer">
          <div class="text-right">
            <a @click="doCancel()" class="btn btn-default editbtn mr-3">取消</a>
            <a @click="isEdit ? doUpdate() : doInsert()" class="btn btn-primary editbtn">確認</a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { commonMixin } from "@/mixins/common";
import { updateCoverageItemDetail, insertCoverageItemDetail, getCoverageItemDetailByName } from "@/service";
export default {
  name: "CoverageItemAddModal",
  mixins: [commonMixin],
  data() {
    return {
      options: {
        category: [],
        calculationWay: [
          {
            name: "Formula01",
            value: "Formula01",
          },
          {
            name: "Formula04",
            value: "Formula04",
          },
          {
            name: "Formula05",
            value: "Formula05",
          },
          {
            name: "Formula06",
            value: "Formula06",
          },
          {
            name: "Formula07",
            value: "Formula07",
          },
          {
            name: "Formula08",
            value: "Formula08",
          },
          {
            name: "Formula09",
            value: "Formula09",
          },
        ],
      },
      form: {
        itemKind: "",
        itemKindName: "",
        itemName: "",
        itemMethodName: "",
        coverageCategoryId: "",
      },
      isMethodNameError: false,
      isItemNameError: false,
      isCategoryKindError: false,
    };
  },
  props: {
    open: {
      type: Boolean,
      default: false,
    },
    isEdit: {
      type: Boolean,
      default: false,
    },
    coverageItemDetail: {
      type: Object,
      default: () => {
        return null;
      },
    },
    coverageCategoryOption: {
      type: Array,
      default: () => {
        return [];
      },
    },
  },
  watch: {
    open: "initData",
  },
  methods: {
    doCancel() {
      this.$emit("cancel");
      this.$validator.reset();
      this.$toast.info({ title: this.isEdit ? "取消編輯" : "取消新增" });
    },
    doUpdate() {
      if (this.validateForm()) {
        return;
      }
      this.form.itemKindName = this.options.category.find((item) => item.coveragecategoryid == this.form.itemKind).name;
      updateCoverageItemDetail(this.$store.state.userInfo.id, this.form).then(
        (result) => {
          if (result.header && result.header.status == "200") {
            this.$toast.info({ title: "編輯成功" });
            this.$emit("close");
          } else {
            this.$toast.info({ title: result.header.message });
          }
        }
      );
    },
    async doInsert() {
      if (this.validateForm()) {
        return;
      }
      this.form.itemKindName = this.options.category.find((item) => item.coveragecategoryid == this.form.itemKind).name;
      const res = await getCoverageItemDetailByName(this.$store.state.userInfo.id, this.form);
      console.log(res)
      if (res.header && res.header.status == "200") {
        this.$toast.info({ title: "此保障項目名稱已存在，請勿重複新增" });
      } else if (res.header && res.header.status == "400") {
        insertCoverageItemDetail(this.$store.state.userInfo.id, this.form).then(
          (result) => {
            if (result.header && result.header.status == "200") {
              this.$toast.info({ title: "新增成功" });
              this.$emit("close");
            } else {
              this.$toast.info({ title: result.header.message });
            }
          }
        );
      }
    },
    initData() {
      this.isCategoryKindError = false;
      this.isItemNameError = false;
      this.isMethodNameError = false;
      this.options.category = this.coverageCategoryOption;
      if (this.isEdit) {
        this.form.itemKind = this.coverageItemDetail.parent;
        this.form.itemName = this.coverageItemDetail.name;
        this.form.itemMethodName = this.coverageItemDetail.methodname;
        this.form.coverageCategoryId = this.coverageItemDetail.coveragecategoryid;
        this.form.sequenceNumber = this.coverageItemDetail.sequencenumber;
      } else {
        this.form.itemKind = "";
        this.form.itemName = "";
        this.form.itemMethodName = "";
        this.form.coverageCategoryId = "";
      }
    },
    validateForm() {
      let isError = false;
      this.isCategoryKindError = false;
      this.isItemNameError = false;
      this.isMethodNameError = false;
      if (!this.form.itemKind) {
        isError = true;
        this.isCategoryKindError = true;
        this.$toast.info({ title: "[保障項目歸類]選單必須選擇" });
      }
      if (!this.form.itemName) {
        isError = true;
        this.isItemNameError = true;
        this.$toast.info({ title: "[保障項目名稱]欄位不得為空" });
      }
      if (!this.form.itemMethodName) {
        isError = true;
        this.isMethodNameError = true;
        this.$toast.info({ title: "[計算方式]選單必須選擇" });
      }
      return isError;
    },
  },
};
</script>
<style scoped>
.modal.fade .modal-body {
  min-height: auto;
}
.editbtn {
  width: 120px;
  height: 40px;
}
</style>
